export default "__VITE_ASSET__9El7h8I1__"